import { render, staticRenderFns } from "./ProductStockInfo.vue?vue&type=template&id=13bdbf34&scoped=true"
import script from "./ProductStockInfo.vue?vue&type=script&lang=js"
export * from "./ProductStockInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductStockInfo.vue?vue&type=style&index=0&id=13bdbf34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdbf34",
  null
  
)

export default component.exports